import {Component, Inject, Input} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {
    MX_TRANSLATE_SERVICE_TOKEN,
    MxButtonModel,
    MxButtonModule,
    MxDynamicFieldsModule,
    MxTranslateService
} from 'mx-core';
import {MatCard, MatCardActions, MatCardContent, MatCardHeader, MatCardTitle} from '@angular/material/card';
import {PrlLanguageModule} from '../../../prl-language/prl-language.module';

@Component({
    selector: 'prl-edit-variables-dialog-component',
  imports: [
    MatCard,
    MatCardActions,
    MatCardContent,
    MxButtonModule,
    MxDynamicFieldsModule,
    PrlLanguageModule,
    MatCardHeader,
    MatCardTitle
  ],
    templateUrl: './prl-edit-variables-dialog-component.html',
    styleUrl: './prl-edit-variables-dialog-component.scss',
})
export class PrlEditVariablesDialogComponent {
    @Input()
    vars: Map<string, string>;

    form: FormGroup ;

    protected showAllVars = false;
    protected readonly indexes = Array.from({length: 10}, (_, i) => i + 1);

    protected expandButton: MxButtonModel;

    protected submitButton: MxButtonModel;
    protected cancelButton: MxButtonModel;

    constructor(
        private readonly dialogRef: MatDialogRef<PrlEditVariablesDialogComponent>,
        private readonly fb: FormBuilder,
        @Inject(MX_TRANSLATE_SERVICE_TOKEN) private readonly translateService: MxTranslateService,
        @Inject(MAT_DIALOG_DATA) public data: {
            vars: Map<string, string>
        }
    ) {
        this.vars = data.vars;
        this.form = this.fb.group({
            var1: [this.vars.get('var1'), [Validators.maxLength(100)]],
            var2: [this.vars.get('var2'), [Validators.maxLength(100)]],
            var3: [this.vars.get('var3'), [Validators.maxLength(100)]],
            var4: [this.vars.get('var4'), [Validators.maxLength(100)]],
            var5: [this.vars.get('var5'), [Validators.maxLength(100)]],
            var6: [this.vars.get('var6'), [Validators.maxLength(100)]],
            var7: [this.vars.get('var7'), [Validators.maxLength(100)]],
            var8: [this.vars.get('var8'), [Validators.maxLength(100)]],
            var9: [this.vars.get('var9'), [Validators.maxLength(100)]],
            var10: [this.vars.get('var10'), [Validators.maxLength(100)]],
        });
    }

    ngOnInit(): void {
        this.expandButton = {
            label: () => this.translateService.getTranslatedLabel(
                this.showAllVars
                    ? 'label.marketing.tools.see.less.button'
                    : 'label.marketing.tools.see.more.button'
            ),
            tooltip: () => this.translateService.getTranslatedLabel(
                this.showAllVars
                    ? 'label.marketing.tools.see.less.button'
                    : 'label.marketing.tools.see.more.button'
            ),
            className: 'mxs-button--secondary',
            clickHandler: () => this.toggleVars()
        };
        this.submitButton = {
            label: () => this.translateService.getTranslatedLabel('label.submit'),
            tooltip: () => this.translateService.getTranslatedLabel('label.submit'),
            className: 'mxs-button--primary',
            clickHandler: () => this.updateVars()
        };
        this.cancelButton = {
            label: () => this.translateService.getTranslatedLabel('label.cancel'),
            tooltip: () => this.translateService.getTranslatedLabel('label.cancel'),
            className: 'mxs-button--secondary',
            clickHandler: () => this.dialogRef.close(null)
        };
    }

    protected toggleVars(): void {
        this.showAllVars = !this.showAllVars;
    }

    private updateVars = () => {
        const varsMap = new Map<string, string>(Object.entries(this.form.value));
        this.dialogRef.close(varsMap);
    };
}